import {Card} from "@material-ui/core";
import {EditProps} from "react-admin";
import {DefaultEdit} from "../../components/DefaultEdit";
import {WorkPermitForm} from "./WorkPermitForm";

export const WorkPermitEdit = (props: EditProps) => {
  return (
    <DefaultEdit {...props} component={Card}>
      <WorkPermitForm />
    </DefaultEdit>
  );
};
